import type { FocalPoint } from '@lib/helpers/focal-point'
import type { EventDto } from '@lib/dto/event.dto'

/** A photograph to show, and where its subject is. */
export interface EventPhoto {
  src: string | null
  focalPoint: FocalPoint | null
}

/**
 * The photograph that stands for an event.
 *
 * Its own, if somebody set one — and then no focal point, because an event has
 * no focal point of its own to set. Otherwise **its venue's**, with the venue's
 * focal point, because that is a photograph of where the event actually is. A
 * shipped stock manor was neither.
 *
 * One function so the row and the page cannot disagree: clicking an event that
 * showed one building and landing on a page showing another is the kind of thing
 * that reads as the wrong record having opened.
 *
 * Null when neither exists, and the frame shows the empty well on the plan
 * grid — never a stand-in photograph, which would read as the venue's own.
 */
export function eventPhoto(event: Pick<EventDto, 'coverImageUrl' | 'venueCoverImageUrl' | 'venueCoverFocalPoint'>): EventPhoto {
  if (event.coverImageUrl !== null) {
    return { src: event.coverImageUrl, focalPoint: null }
  }
  return { src: event.venueCoverImageUrl, focalPoint: event.venueCoverFocalPoint }
}
